import { cn } from '@/shared/lib/utils'

const MODULE_ACCENT: Record<string, string> = {
  sdi: '#0F7173', llr: '#C9A84C', are: '#E8562A', gfo: '#7B61FF',
}

interface PageHeaderProps {
  moduleId: 'sdi' | 'llr' | 'are' | 'gfo'
  moduleFullName: string
  title: string
  subtitle?: string
  syncStatus?: { label: string; ok: boolean }
  actions?: React.ReactNode
}

export function PageHeader({
  moduleId, moduleFullName, title, subtitle, syncStatus, actions,
}: PageHeaderProps) {
  const accent = MODULE_ACCENT[moduleId] ?? '#C9A84C'

  return (
    <div className="mb-6">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          {/* Eyebrow */}
          <p
            className="text-[9px] font-medium tracking-[0.22em] uppercase mb-1"
            style={{ color: accent }}
          >
            {moduleFullName} · {moduleId.toUpperCase()}
          </p>

          {/* Title */}
          <h1 className="font-serif text-[26px] font-bold text-ink tracking-[-0.03em] leading-tight truncate">
            {title}
          </h1>

          {/* Sync status + subtitle */}
          {(syncStatus || subtitle) && (
            <div className="flex items-center gap-2 mt-1.5 flex-wrap">
              {syncStatus && (
                <div className="flex items-center gap-1.5">
                  <span
                    className={cn(
                      'w-1.5 h-1.5 rounded-full flex-shrink-0',
                      syncStatus.ok ? 'bg-teal' : 'bg-brick animate-gold-pulse',
                    )}
                  />
                  <span className="text-[11px] font-sans font-light text-ink-muted">
                    {syncStatus.label}
                  </span>
                </div>
              )}
              {subtitle && (
                <span className="text-[11px] font-sans font-light text-ink-faint">
                  {syncStatus ? '· ' : ''}{subtitle}
                </span>
              )}
            </div>
          )}
        </div>

        {/* Actions */}
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0 pt-0.5">
            {actions}
          </div>
        )}
      </div>

      {/* Gold divider */}
      <div className="divider-gold mt-4" />
    </div>
  )
}
